import { type QueryObserverResult, useQuery } from '@tanstack/react-query';
import { getAgentsByProjectId, type AiAgent } from '../api';
import { useUserStore } from '@stores/user';

export interface UseAgentsResult {
  agents?: AiAgent[];
  agentsPending: boolean;
  agentsError?: string;
  agentsRefetching: boolean;
  refetchAgents: () => Promise<QueryObserverResult<AiAgent[], Error>>;
}

export const useAgents = (): UseAgentsResult => {
  const authStore = useUserStore((state) => state.authStoreInstance);
  const projectId = authStore?.projectId;
  const accessToken = authStore?.accessToken;
  const isLoggedIn = Boolean(authStore?.isLoggedIn);
  const isEnabled = Boolean(projectId && accessToken && isLoggedIn);

  const { data, isPending, error, refetch, isRefetching } = useQuery({
    queryKey: ['agents', projectId],
    queryFn: async () => {
      return getAgentsByProjectId(
        { projectId, accessToken },
        {
          throwOnError: true,
        },
      );
    },
    enabled: isEnabled,
    meta: {
      persist: false,
    },
  });

  return {
    agents: data || [],
    agentsPending: isPending,
    agentsError: error?.message,
    agentsRefetching: isRefetching,
    refetchAgents: refetch,
  };
};
